import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Send } from "lucide-react";
import { formatDateTimeWAT } from "@/lib/format";

export const GuardMessenger = () => {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [messages, setMessages] = useState([]);
  const [body, setBody] = useState("");

  const loadUsers = useCallback(async () => {
    const r = await api.get("/users");
    setUsers(r.data.filter(u => ["supervisor", "ops_manager", "super_admin"].includes(u.role)));
  }, []);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  const open = async (other) => {
    const thread_id = [user.id, other.id].sort().join(":");
    setSelected({ ...other, thread_id });
    const r = await api.get(`/messages?thread_id=${thread_id}`);
    setMessages(r.data);
  };

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;
    await api.post("/messages", { thread_id: selected.thread_id, to_user_id: selected.id, body });
    setBody("");
    const r = await api.get(`/messages?thread_id=${selected.thread_id}`);
    setMessages(r.data);
  };

  if (!selected) {
    return (
      <div className="space-y-2">
        <div className="text-muted" style={{ fontSize: 13, marginBottom: 8 }}>Talk to supervisors and managers</div>
        {users.map(u => (
          <button key={u.id} onClick={() => open(u)} className="s-card w-full text-left flex items-center gap-3 tap-target" data-testid={`gthread-${u.id}`}>
            <div style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(46,202,200,0.15)",
                          display: "flex", alignItems: "center", justifyContent: "center", color: "#2ECAC8", fontWeight: 500 }}>
              {u.name[0]}
            </div>
            <div>
              <div style={{ fontSize: 14, color: "#fff" }}>{u.name}</div>
              <div className="text-muted" style={{ fontSize: 12 }}>{u.role.replace("_", " ")}</div>
            </div>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col" style={{ height: "calc(100vh - 280px)" }}>
      <button onClick={() => setSelected(null)} className="text-muted text-left mb-2" style={{ fontSize: 13 }}>← Back</button>
      <div className="s-card" style={{ padding: 12, marginBottom: 12 }}>
        <div style={{ fontSize: 15, color: "#fff" }}>{selected.name}</div>
      </div>
      <div style={{ flex: 1, overflowY: "auto", paddingBottom: 12 }}>
        {messages.map(m => {
          const mine = m.from_user_id === user.id;
          return (
            <div key={m.id} style={{ display: "flex", justifyContent: mine ? "flex-end" : "flex-start", marginBottom: 8 }}>
              <div style={{ maxWidth: "78%", padding: "10px 14px", borderRadius: 12,
                            background: mine ? "var(--brand-teal)" : "#1F3245", color: "#fff", fontSize: 14 }}>
                {m.body}
                <div style={{ fontSize: 10, marginTop: 4, opacity: 0.7 }}>{formatDateTimeWAT(m.created_at)}</div>
              </div>
            </div>
          );
        })}
      </div>
      <form onSubmit={send} className="flex gap-2">
        <input className="s-input" value={body} onChange={(e) => setBody(e.target.value)} placeholder="Type a message..." data-testid="gmsg-input" />
        <button className="btn-primary tap-target" data-testid="gmsg-send"><Send size={16} /></button>
      </form>
    </div>
  );
};
